import React from 'react'

import {
    Box,

    /* Hooks */
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'

/* Components */
import LoyaltyProgramMobile from './loyalty-program-mobile'
import LoyaltyProgramDesktop from './loyalty-program-desktop'

const LoyaltyProgram = React.forwardRef(({ }, ref) => {
    const isMobile = useBreakpointValue({ base: true, lg: false })

    return (
        <Box ref={ref}>
            {isMobile ? (
                <LoyaltyProgramMobile key="loyaly-program-mobile" />
            ) : (
                <LoyaltyProgramDesktop key="loyaly-program-destop" />
            )}
        </Box>
    )
})

export default LoyaltyProgram
